import React from 'react';

import PropTypes from 'prop-types';

import { connect, useDispatch, useSelector } from 'react-redux';

import { setLanguage } from 'store/actions/language/language';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import DefaultComponent from './DefaultComponent';

const DefaultLanguage = props => {
  const { language } = props;
  const dispatch = useDispatch();

  const [item, setItem] = React.useState(null);

  const [defaultLanguage, setDefaultLanguage] = React.useState(
    UserSessionDataHandler.getFromUserSettingsObjectInStore(
      UserSessionDataHandler.defaultLanguage
    ) || 'pl'
  );

  const useString = name => {
    const lang = useSelector(state => state.language);
    return lang.userSettings.mainSettings[name];
  };

  const handleChange = event => {
    setDefaultLanguage(event.target.value);
    UserSessionDataHandler.saveToUserSettingsObjectInStorage(
      UserSessionDataHandler.defaultLanguage,
      event.target.value
    );
    dispatch(setLanguage(event.target.value));
  };

  const subtitle = useString('defaultLanguage_');

  React.useEffect(() => {
    setItem({
      name: 'user-language',
      label: 'user-language-label',
      subtitle,
      menu: [
        {
          key_: language.userSettings.mainSettings.language.en_,
          value_: 'en',
        },
        {
          key_: language.userSettings.mainSettings.language.pl_,
          value_: 'pl',
        },
      ],
    });
  }, [defaultLanguage]);

  return (
    <DefaultComponent
      item={item}
      defaultItem={defaultLanguage}
      handleChange={handleChange}
    />
  );
};

DefaultLanguage.propTypes = {
  language: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(DefaultLanguage);
